import { render, staticRenderFns } from "./paidDaysOffTable.vue?vue&type=template&id=2d49dafa&scoped=true&"
import script from "./paidDaysOffTable.vue?vue&type=script&lang=js&"
export * from "./paidDaysOffTable.vue?vue&type=script&lang=js&"
import style0 from "./paidDaysOffTable.vue?vue&type=style&index=0&id=2d49dafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d49dafa",
  null
  
)

export default component.exports